<template>
  <section class="hero is-white">
    <div class="hero-body">
      <div class="breadcrumb-wrapper">
        <img src="@/assets/images/icons/icon-home.png" alt="" class="icon-home">
        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li><router-link to="/index">Trang chủ</router-link></li>
            <li class="is-active"><a>Admin</a></li>
          </ul>
        </nav>
      </div>
      <div class="container">
        <admin-menu :activeLink="'/admin'"/>

        <h1 class="title is-4 has-text-centered">Danh sách tài khoản ( {{totalAccount}} )</h1>
        <div>
          <download-csv class="btn-download" :data="dataExport" v-if="!isLoadingParticipants">
            Danh sách tất cả participant
          </download-csv>
          <div class="button is-loading" v-else/>
        </div>
        <div class="mt-20 mb-20">
          <autocomplete
            :items="accountsSearch.map(({username}) => username)"
            :label="'Lọc theo tài khoản'"
            @input="filterByKeyword"
          />
        </div>
        <div class="admin account-management">
          <b-table
            :data="filteredAccounts"
            :paginated="false"
            :sort-icon-size="'is-small'"
            :sticky-header="true"
            class="table is-fullwidth"
            v-if="filteredAccounts&&filteredAccounts.length">
              <template slot-scope="props">
                <b-table-column label="STT">
                  {{props.index+1}}
                </b-table-column>
                <b-table-column>
                  <b-icon
                    @click.native="toggleEditAccount(props.row._id, true)"
                    v-if="selectedAccounts&&!selectedAccounts[props.row._id].enableModified"
                    class="pointer"
                    icon="user-edit"
                    pack="fas"
                    size="is-small"
                    type="is-info"/>
                  <fragment v-else>
                    <b-icon
                      @click.native="updateAccountRow(props.row._id)"
                      class="pointer"
                      icon="check"
                      pack="fas"
                      size="is-small"
                      type="is-info"/>
                    <b-icon
                      @click.native="toggleEditAccount(props.row._id)"
                      class="pointer close-icon"
                      icon="times"
                      pack="fas"
                      size="is-small"
                      type="is-danger"/>
                  </fragment>
                </b-table-column>
                <b-table-column
                  field="username"
                  label="Tài khoản"
                  sortable>
                  <router-link
                    :to="{name: 'manageUser', params: { username: props.row.username }}">
                      {{props.row.username}}</router-link>
                </b-table-column>
                <b-table-column
                  field="firstName"
                  label="Tên"
                  sortable>
                    {{props.row.firstName}}
                </b-table-column>
                <b-table-column
                  field="email"
                  label="Email"
                  sortable>
                    {{props.row.email}}
                </b-table-column>
                <b-table-column
                  field="phone"
                  label="Số điện thoại"
                  sortable>
                    {{props.row.phone}}
                </b-table-column>
                <b-table-column
                  field="isActive"
                  label="Trạng thái"
                  sortable>
                    <fragment v-if="selectedAccounts&&!selectedAccounts[props.row._id].enableModified">{{props.row.isActive}}</fragment>
                    <fragment v-else>
                      <div>
                        <b-radio
                          :native-value="true"
                          type="is-info"
                          v-if="selectedAccounts"
                          v-model="selectedAccounts[props.row._id].isActive">
                            Active</b-radio>
                      </div>
                      <div>
                        <b-radio
                          :native-value="false"
                          type="is-info"
                          v-if="selectedAccounts"
                          v-model="selectedAccounts[props.row._id].isActive">
                            Deactive</b-radio>
                      </div>
                    </fragment>
                </b-table-column>
                <b-table-column
                  field="startAt"
                  label="Ngày đăng ký"
                  sortable>
                    <fragment v-if="selectedAccounts&&!selectedAccounts[props.row._id].enableModified">
                      {{getFormatDate(props.row.startAt)}}</fragment>
                    <fragment v-else>
                      <datepicker
                        :format="dateFormatter"
                        :input-class="'input'"
                        :placeholder="'Please select a date'"
                        v-if="selectedAccounts"
                        v-model="selectedAccounts[props.row._id].startAt"/>
                    </fragment>
                </b-table-column>
                <b-table-column
                  field="limit"
                  label="Giới hạn người dùng"
                  sortable>
                    <fragment
                      v-if="selectedAccounts&&!selectedAccounts[props.row._id].enableModified">
                        {{props.row.limit}}</fragment>
                    <fragment v-else>
                      <b-input
                        min="0"
                        type="number"
                        v-if="selectedAccounts"
                        v-model="selectedAccounts[props.row._id].limit"
                      />
                    </fragment>
                </b-table-column>
                <b-table-column
                  field="level"
                  label="Loại tài khoản"
                  sortable>
                    <fragment
                      v-if="selectedAccounts&&!selectedAccounts[props.row._id].enableModified">
                        {{getAccountType(props.row.level)}}</fragment>
                    <fragment v-else>
                      <multiselect
                        :allow-empty="true"
                        :id="props.row._id"
                        :searchable="true"
                        :show-labels="false"
                        :options="levelOptions"
                        v-model="selectedBusiness"
                        label="name"
                        placeholder="Please select level"
                        track-by="result">
                          <template slot-scope="{ option }">{{ option.name }}</template>
                      </multiselect>
                    </fragment>
                </b-table-column>
                <b-table-column label="Xoá">
                  <span class="button is-danger" @click="confirmCustomDelete(props.row)">Xoá</span>
                </b-table-column>
              </template>
          </b-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import Utils from "../components/shared/Utils";
import _ from "lodash";
import Vue from 'vue'
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
export default {
  data() {
    return {
      selectedAccounts: null,
      levelOptions: [
        { name: "Free", result: 1 },
        { name: "Business", result: 2 }
      ],
      totalAccount: 0,
      keyword: "",
      isLoadingParticipants: false,
      participants: [],
      selectedBusiness: null,
      selectedId: ''
    };
  },
  components: {
    Fragment: () => import("vue-fragment").then(({ Fragment }) => Fragment),
    Datepicker: () => import("vuejs-datepicker"),
    Multiselect: () => import("vue-multiselect"),
    Autocomplete: () => import("../components/shared/Autocomplete"),
    AdminMenu: () => import("../components/Admin/AdminMenu")
  },
  created() {
    this.isLoadingParticipants = true
    this.fetchAccountList().then(() => {
      this.selectedAccounts = this.accounts.reduce((result, account) => {
        result = {
          ...result,
          [account._id]: {
            enableModified: false,
            username: account.username,
            isActive: account.isActive,
            startAt: account.startAt,
            limit: account.limit,
            level: account.level
          }
        };
        return result;
      }, {});

      this.totalAccount = _.size(this.accounts);

      this.getAllParticipants(this.accounts).then(participants => {
        this.participants = participants.data
      }).finally(() => {
        this.isLoadingParticipants = false
      })
    });
  },
  methods: {
    ...mapActions("hostAccount", ["fetchAccountList", "updateAccount", "deleteAccount", "getAllParticipants"]),
    getAccountType: Utils.getAccountType,
    getFormatDate: Utils.getFormatDate,
    dateFormatter(date) {
      return moment(date).format("D/M/YYYY");
    },
    changeLevel(id) {
      this.selectedId = id
    },
    toggleEditAccount(id, editStatus = false) {
      this.selectedAccounts = {
        ...this.selectedAccounts,
        [id]: { ...this.selectedAccounts[id], enableModified: editStatus }
      };
      if(editStatus) {
        if(this.selectedId.length) this.selectedAccounts[this.selectedId].enableModified = false
        this.selectedBusiness = this.levelOptions.find(business => business.result === this.selectedAccounts[id].level)
        this.selectedId = id
      } else {
        this.selectedBusiness = null
        this.selectedId = ''
      }
    },
    updateAccountRow(id) {
      let { isActive, startAt, limit, level, username } = this.selectedAccounts[
        id
      ];
      limit = Number(limit);
      if(this.selectedBusiness) {
        this.updateAccount({ isActive, startAt, limit, level, username }).then(
          () => {
            this.selectedBusiness = null;
            this.selectedId = '';
            this.selectedAccounts[id].enableModified = false;
          }
        );
      } else {
        this.$toast.open({
          message: "Xin chọn loại tài khoản",
          type: "is-danger"
        })
      }
    },

    filterByKeyword(keyword) {
      this.keyword = keyword;
    },

    confirmCustomDelete(acount) {
      this.$dialog.confirm({
        title: 'Xoá tài khoản',
        message: 'Bạn có chắc <b>xoá</b> tài khoản của bạn? Lệnh này không thể hoàn tác.',
        confirmText: 'Xoá tài khoản',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteAccount(acount).then(res => {
            
            this.fetchAccountList().then(() => { 
              if(res.data.status) {
                this.$toast.open('Tài khoản đã được xoá!')
              } else {
                this.$toast.open('Không thể xoá tài khoản')
              }
            });
          })
          
        },
        cancelText: 'Đóng'
      })
    }
  },
  computed: {
    ...mapState("hostAccount", ["accounts"]),
    accountsSearch() {
      return this.accounts || [];
    },
    filteredAccounts() {
      let result = this.accounts || []
      if (this.keyword === "") {
        return result.sort((party1, party2) => {
          return party1.username.toLowerCase().localeCompare(party2.username.toLowerCase(), 'en', {numeric: true})
        });
      }
      const filterResult = result
        ? result
        .filter(({ username }) => username.includes(this.keyword))
        .sort((party1, party2) => {
          return party1.username.toLowerCase().localeCompare(party2.username.toLowerCase(), 'en', {numeric: true})
        })
        : [];
      return filterResult;
    },
    dataExport() {
      const data = [];
      if(!this.participants) return [];
      this.participants.map(item => {
        data.push({
          "Tài khoản": item.name,
          "Tên": item.firstName,
          "Email": item.email,
          "Trạng thái Kích Hoạt": item.disabled,
          "Trạng thái Khoá": item.locked,
          "Người quản lý": item.owner
        }) 
      })
      return data;
    }
  },
  watch: {
    selectedBusiness() {
      if(this.selectedBusiness) {
        this.selectedAccounts[this.selectedId].level = this.selectedBusiness.result
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scope>
@import "@/assets/scss/form.scss";
.has-line {
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  hyphens: auto;
  word-break: break-word;
}
.pointer {
  cursor: pointer;
}
.close-icon {
  margin-left: 10px;
}
.hero-body {
  padding-top: 0;
}

.account-management {
  padding: 20px;
}
.w70 {
  max-width: 70px;
}
.w55 {
  max-width: 55px;
}
.account-type {
  flex: 1 1 100px;
}
.hero.is-white .tabs {
  li.is-active a {
    color: #14afb4;
    border-bottom: 1px solid #14afb4;
  }
  a {
    margin-bottom: 0;
  }
}
</style>